/**
 * @generated SignedSource<<22ecfb49e3c2856e89f63a40e9fe0bd7>>
 * @relayHash 8824351f0529abac5573900b2bee2db5
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 2f8b43e5b1993f0813a23a44917516743e194299c3565ccbf17994b391776751

import type { ConcreteRequest, Query } from 'relay-runtime';
export type SitePermissionType = "ANONYMOUS" | "APP" | "EXTERNAL" | "INTERNAL" | "JSD" | "%future added value";
export type SitePermissionTypeFilter = "ALL" | "EXTERNALCOLLABORATOR" | "NONE" | "%future added value";
export type UserAndGroupSearchQuery$variables = {
  maxResults?: number | null | undefined;
  searchTerm: string;
  sitePermissionTypeFilter?: SitePermissionTypeFilter | null | undefined;
  withGroups?: boolean | null | undefined;
  withUsers?: boolean | null | undefined;
};
export type UserAndGroupSearchQuery$data = {
  readonly userGroupSearch: {
    readonly groups?: ReadonlyArray<{
      readonly id: string | null | undefined;
      readonly name: string | null | undefined;
      readonly permissionType: SitePermissionType | null | undefined;
    } | null | undefined>;
    readonly users?: ReadonlyArray<{
      readonly accountId?: string | null | undefined;
      readonly displayName: string | null | undefined;
      readonly permissionType: SitePermissionType | null | undefined;
      readonly profilePicture: {
        readonly path: string;
      } | null | undefined;
      readonly type: string | null | undefined;
    } | null | undefined>;
  } | null | undefined;
};
export type UserAndGroupSearchQuery = {
  response: UserAndGroupSearchQuery$data;
  variables: UserAndGroupSearchQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": 50,
  "kind": "LocalArgument",
  "name": "maxResults"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "searchTerm"
},
v2 = {
  "defaultValue": "NONE",
  "kind": "LocalArgument",
  "name": "sitePermissionTypeFilter"
},
v3 = {
  "defaultValue": true,
  "kind": "LocalArgument",
  "name": "withGroups"
},
v4 = {
  "defaultValue": true,
  "kind": "LocalArgument",
  "name": "withUsers"
},
v5 = [
  {
    "kind": "Variable",
    "name": "maxResults",
    "variableName": "maxResults"
  },
  {
    "kind": "Variable",
    "name": "query",
    "variableName": "searchTerm"
  },
  {
    "kind": "Variable",
    "name": "sitePermissionTypeFilter",
    "variableName": "sitePermissionTypeFilter"
  }
],
v6 = {
  "kind": "ScalarField",
  "name": "type"
},
v7 = {
  "kind": "ScalarField",
  "name": "displayName"
},
v8 = {
  "kind": "ScalarField",
  "name": "permissionType"
},
v9 = {
  "concreteType": "Icon",
  "kind": "LinkedField",
  "name": "profilePicture",
  "plural": false,
  "selections": [
    {
      "kind": "ScalarField",
      "name": "path"
    }
  ]
},
v10 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "kind": "ScalarField",
      "name": "accountId"
    }
  ],
  "type": "KnownUser"
},
v11 = {
  "condition": "withGroups",
  "kind": "Condition",
  "passingValue": true,
  "selections": [
    {
      "concreteType": "Group",
      "kind": "LinkedField",
      "name": "groups",
      "plural": true,
      "selections": [
        {
          "kind": "ScalarField",
          "name": "id"
        },
        {
          "kind": "ScalarField",
          "name": "name"
        },
        (v8/*: any*/)
      ]
    }
  ]
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/),
      (v4/*: any*/)
    ],
    "kind": "Fragment",
    "name": "UserAndGroupSearchQuery",
    "selections": [
      {
        "args": (v5/*: any*/),
        "concreteType": "GraphQLUserAndGroupSearchResults",
        "kind": "LinkedField",
        "name": "userGroupSearch",
        "plural": false,
        "selections": [
          {
            "condition": "withUsers",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
              {
                "kind": "LinkedField",
                "name": "users",
                "plural": true,
                "selections": [
                  (v6/*: any*/),
                  (v7/*: any*/),
                  (v8/*: any*/),
                  (v9/*: any*/),
                  (v10/*: any*/)
                ]
              }
            ]
          },
          (v11/*: any*/)
        ]
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v0/*: any*/),
      (v3/*: any*/),
      (v4/*: any*/),
      (v2/*: any*/)
    ],
    "kind": "Operation",
    "name": "UserAndGroupSearchQuery",
    "selections": [
      {
        "args": (v5/*: any*/),
        "concreteType": "GraphQLUserAndGroupSearchResults",
        "kind": "LinkedField",
        "name": "userGroupSearch",
        "plural": false,
        "selections": [
          {
            "condition": "withUsers",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
              {
                "kind": "LinkedField",
                "name": "users",
                "plural": true,
                "selections": [
                  {
                    "kind": "ScalarField",
                    "name": "__typename"
                  },
                  (v6/*: any*/),
                  (v7/*: any*/),
                  (v8/*: any*/),
                  (v9/*: any*/),
                  (v10/*: any*/)
                ]
              }
            ]
          },
          (v11/*: any*/)
        ]
      }
    ]
  },
  "params": {
    "cacheID": "8824351f0529abac5573900b2bee2db5",
    "id": "2f8b43e5b1993f0813a23a44917516743e194299c3565ccbf17994b391776751",
    "metadata": {},
    "name": "UserAndGroupSearchQuery",
    "operationKind": "query",
    "text": "query UserAndGroupSearchQuery($searchTerm:String!,$maxResults:Int=50,$withGroups:Boolean=true,$withUsers:Boolean=true,$sitePermissionTypeFilter:SitePermissionTypeFilter=NONE){userGroupSearch(query:$searchTerm,maxResults:$maxResults,sitePermissionTypeFilter:$sitePermissionTypeFilter){users@include(if:$withUsers){__typename,type,displayName,permissionType,profilePicture{path},...on KnownUser{accountId}},groups@include(if:$withGroups){id,name,permissionType}}}"
  }
};
})();

(node as any).hash = "52200fecbeb2441b36c8ceb106bad130";

export default node;
